module.exports = __webpack_public_path__ + "img/BNB-logo.6957e848.svg";